import React, { useState } from 'react';

import { IconButton, makeStyles, TableRow, TableCell } from '@material-ui/core';
import { InformeItem } from './InformeItem';

import { ListAltSharp } from '@material-ui/icons';

const useStyles = makeStyles({
  iconEstado: {
    '&:hover': {
      backgroundColor: '#80808026',
    },
  },
});

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const InformesHistorialItem = (props) => {
  const classes = useStyles();
  const [tituloModal, setTituloModal] = useState('');
  const [openDiag, setOpenDiag] = useState(false);

  const { informe, turnos } = props;

  return (
    <React.Fragment>
      {openDiag && (
        <InformeItem
          open={openDiag}
          close={() => {
            setOpenDiag(false);
          }}
          titulo={tituloModal}
          disabled={true}
          informe={informe}
          turnos={turnos}
        />
      )}
      <TableRow className={classes.iconEstado}>
        <TableCell>{informe?.nombreEcografia}</TableCell>
        <TableCell>{informe?.nombreProfesional}</TableCell>
        <TableCell>
          {new Date(informe?.fecha).toLocaleString('es', optionsfecha)}
        </TableCell>
        <TableCell>
          {informe?.informe.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                setOpenDiag(!openDiag);
                setTituloModal('Informe');
              }}
            >
              <ListAltSharp />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
